/** Import React and 3rd party libs */
import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Settings from "@material-ui/icons/Settings";

// Components

// Subcomponents
import ConfigureCalculated from "../../StepComponents/StepEdit/ConfigureCalculated";
import StepNote from "../../StepComponents/StepNote";
import ViewTitle from "../../StepComponents/ViewTitle";
import CalculatedInput from "./CalculatedInput";

// Services
import {
  getCommonTabs,
  EditRow,
  isInputDisabled,
  getIconClass
} from "../StepTypesUtility";
import { getStepRowClass } from "services/StepService";

// Queries
/** Import all graphql queries */

// Assets
import stepsStyle from "assets/jss/material-dashboard-pro-react/components/stepsStyle.jsx";

// Variables
/** Declare all constant variables */

// Functions
const StepIcon = ({ classes, step }) => {
  return (
    <TableCell className={classes.tableCheck}>
      <div className={getIconClass(step, classes)}>
        <Icon>functions</Icon>
      </div>
    </TableCell>
  );
};

const StepContent = props => {
  const { classes, step, steps, mode } = props;
  const isDisabled = isInputDisabled(mode);
  return (
    <TableCell className={classes.tableContent}>
      <ViewTitle {...props} />
      <CalculatedInput step={step} steps={steps} isDisabled={isDisabled} />
    </TableCell>
  );
};

/**
 * Calculation Step
 */
const Calculation = props => {
  const {
    classes,
    step,
    steps,
    updateStep,
    editing,
    setEditState,
    noteOpen,
    setNoteState
  } = props;
  const editProps = { editing, setEditState, noteOpen, setNoteState };
  const tabs = getCommonTabs(step, updateStep);
  const showRowDividers = true;
  const primaryTableRowClass = getStepRowClass(
    classes,
    showRowDividers,
    editing || noteOpen
  );

  tabs.push({
    tabName: "Configuration",
    tabIcon: Settings,
    tabContent: (
      <ConfigureCalculated step={step} steps={steps} updateStep={updateStep} />
    )
  });

  return (
    <>
      <TableRow key={step.stepId} className={primaryTableRowClass}>
        <StepIcon {...props} step={step} />
        <StepContent {...props} {...editProps} step={step} />
      </TableRow>
      <EditRow classes={classes} open={editing}>
        <CustomTabs title="Configure" headerColor="gray" tabs={tabs} />
      </EditRow>
      <EditRow classes={classes} open={noteOpen}>
        <StepNote step={step} updateStep={updateStep} />
      </EditRow>
    </>
  );
};

export default withStyles(stepsStyle)(Calculation);
